import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { EmulatorAppTableComponent } from './emulator-app-table.component';
import { RemoveAppModalComponent } from '../remove-app-modal/remove-app-modal.component';

@NgModule({
  imports: [SharedModule],
  declarations: [EmulatorAppTableComponent, RemoveAppModalComponent],
  exports: [EmulatorAppTableComponent],
})
export class EmulatorAppTableModule {}
